// CAPABILITY: Account automation API key client wrappers.
// Firebase callable functions own key material; this client only normalizes
// return shapes and maps callable failures into account-page UX messages.

import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";

function serializeTimestamp(value) {
  if (!value) return null;
  if (typeof value === "string") return value;
  if (typeof value.toDate === "function") return value.toDate().toISOString();
  if (typeof value.seconds === "number") return new Date(value.seconds * 1000).toISOString();
  return null;
}

export function normalizeApiKeyMetadata(metadata = {}) {
  return {
    active: metadata.active === true && Boolean(metadata.prefix),
    prefix: metadata.prefix || "",
    created_at: serializeTimestamp(metadata.created_at),
    rolled_at: serializeTimestamp(metadata.rolled_at),
    deleted_at: serializeTimestamp(metadata.deleted_at),
  };
}

async function callApiKeyFunction(name) {
  const callable = httpsCallable(functions, name);
  const { data } = await callable({});
  return {
    ok: data?.ok === true,
    apiKey: data?.apiKey || "",
    metadata: normalizeApiKeyMetadata(data?.metadata),
  };
}

export function createApiKey() {
  return callApiKeyFunction("createAccountApiKey");
}

export function rollApiKey() {
  return callApiKeyFunction("rollAccountApiKey");
}

export function deleteApiKey() {
  return callApiKeyFunction("deleteAccountApiKey");
}

export function mapApiKeyError(error) {
  const code = error?.code || "";
  if (code.includes("permission-denied")) return "API access is available on the Pro plan.";
  if (code.includes("unauthenticated")) return "Sign in again to manage API keys.";
  if (code.includes("failed-precondition")) return error?.message || "This API key action is not available right now.";
  return error?.message || "API key action failed. Try again.";
}
